import elementTypes from "../Elements/elementTypes"
import formulaBuilderTypes from "./formulaBuilderTypes"
import { v4 as idGeneratorV4 } from "uuid"

//Add suffix to ID to ensure that the service does not pick it up as a valid existing ID
export function getNewId(prefix) {
  const usePrefix = prefix ? prefix + "_" : ""

  return `${usePrefix}${idGeneratorV4()}_NEW`
}

export function getNewFunction(title, type, operator, groupOrderNumber) {
  return {
    id: getNewId("FUNC"),
    title: title,
    orderNumber: groupOrderNumber || 1,
    type: type,
    attribute: undefined, //Used to indicate e.g. decimal precision for round
    values: [], //This can hold references to questions or actual number values
    connectingOperator:
      operator || formulaBuilderTypes.operatorNames.addOperator,
    isNew: true,
    isDeleted: false,
  }
}

export function getNewFormulaQuestion(questionOrder, orderNumber, operator) {
  return {
    id: getNewId("QUEST"),
    questionId: questionOrder.question?.id,
    questionGroupId: questionOrder.questionGroup?.id,
    title: questionOrder?.question?.text ?? questionOrder?.questionGroup?.name,
    orderNumber: orderNumber || 1,
    connectingOperator:
      operator || formulaBuilderTypes.operatorNames.addOperator,
    isNew: true,
    isDeleted: false,
    type: questionOrder?.question?.type,
  }
}

export function getNewFormulaOption(option, orderNumber, operator) {
  return {
    id: getNewId("OPT"),
    optionId: option.id,
    title: option.text,
    orderNumber: orderNumber || 1,
    connectingOperator:
      operator || formulaBuilderTypes.operatorNames.addOperator,
    isNew: true,
    isDeleted: false,
    type: elementTypes.checkboxElementId, //only checkbox options are included in formulas for now
  }
}

export function getNewFormulaGroup(title, operator) {
  return {
    id: getNewId("GROUP"),
    title: title,
    groupFunctionType: undefined,
    groupFunctionAttribute: undefined,
    formulas: [],
    connectingOperator:
      operator || formulaBuilderTypes.operatorNames.addOperator,
    isNew: true,
    isDeleted: false,
  }
}

export function getNewFormulaValue(title, type, value, operator) {
  return {
    id: getNewId("VALUE"),
    title: title,
    type: type,
    value: value,
    connectingOperator:
      operator || formulaBuilderTypes.operatorNames.addOperator,
    isNew: true,
    isDeleted: false,
  }
}

export function GetNewFormulaOrder(type, orderNumber, valueObject, operator) {
  let func = undefined
  let question = undefined
  let group = undefined
  let value = undefined
  let option = undefined

  switch (type) {
    case formulaBuilderTypes.formulaTypes.question:
      question = getNewFormulaQuestion(valueObject, undefined, operator)
      break
    case formulaBuilderTypes.formulaTypes.group:
      group = getNewFormulaGroup(undefined, operator)
      break
    case formulaBuilderTypes.formulaTypes.number:
      value = getNewFormulaValue(
        "New number",
        formulaBuilderTypes.formulaTypes.number,
        valueObject,
        operator
      )
      break
    case formulaBuilderTypes.draggableTypes.function:
      func = getNewFunction(
        valueObject.display,
        valueObject.name,
        operator,
        orderNumber
      )

      break
    case formulaBuilderTypes.formulaTypes.option:
      option = getNewFormulaOption(valueObject, undefined, operator)
      break
    default:
      break
  }

  return {
    id: getNewId("orderId"),
    orderNumber,
    function: func,
    question,
    group,
    groupId: undefined,
    functionId: undefined,
    value,
    option,
    isDeleted: false,
    isNew: true,
  }
}
